import script from "./PlaceOrderConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceOrderConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./PlaceOrderConfirmation.vue?vue&type=style&index=0&id=05f5926e&lang=scss"

const __exports__ = script;

export default __exports__